enum EventBusEventName {
  CallAdded = 'call.added',
  CallDeleted = 'call.deleted',
  CallMarkedAsDone = 'call.markedAsDone',
  CallUpdated = 'call.updated',
  CompanyAdded = 'companies.added',
  CompanyAddedRelatedContact = 'company.addedRelatedContact',
  CompanyBackgroundInformationUpdated = 'company.backgroundInformationUpdated',
  CompanyDeactivated = 'company.deactivated',
  CompanyLinked = 'companies.linked',
  CompanyReactivated = 'company.reactivated',
  CompanyUpdated = 'company.updated',
  CompanyUpdatedRelatedContact = 'company.updatedRelatedContact',
  ContactAdded = 'contacts.added',
  ContactUpdated = 'contact.updated',
  CustomerMeetingAddonTrialWasUpgraded = 'customerMeetingAddonTrial.upgraded',
  CustomerMeetingUserAccessWasUpdated = 'customerMeetingUserAccess.updated',
  EmailSent = 'email.sent',
  EmployeeHourlyScheduleUpdated = 'employee.hourlyScheduleUpdated',
  EmployeeTargetsUpdated = 'employee.targetsUpdated',
  ExpensesBookkeepingSent = 'expenses.bookkeepingSent',
  ExpensesMarkedAsApproved = 'expenses.markedApproved',
  ExpensesMarkedAsPending = 'expenses.markedAsPending',
  ExpensesMarkedAsRefused = 'expenses.markedAsRefused',
  FilesUploaded = 'files.uploaded',
  IncomingDocumentUploaded = 'incomingDocument.uploaded',
  InvoiceHolded = 'invoice.holded',
  LayoutAdded = 'layout.added',
  LegacyFilePopupOpened = 'legacyFileDragDrop.popupOpened',
  MaterialAdded = 'material.added',
  MaterialUpdated = 'material.updated',
  MeetingAdded = 'meeting.added',
  MeetingMarkedAsDone = 'meeting.markedAsDone',
  MeetingUpdated = 'meeting.updated',
  OnboardingFeatureBreakdownRequested = 'onboarding.featureBreakdownRequested',
  PageLoaded = 'page.loaded',
  PageReloaded = 'page.reloaded',
  PasswordSet = 'password.set',
  ProjectAdded = 'projects.added',
  ProjectUpdated = 'project.updated',
  QuotationsAdded = 'quotations.added',
  QuotationsBackgroundInformationUpdated = 'quotations.backgroundInformationUpdated',
  QuotationsMarkedAsAccepted = 'quotations.markedAsAccepted',
  QuotationsMarkedAsRefused = 'quotations.markedAsRefused',
  QuotationsMarkedAsSent = 'quotations.markedAsSent',
  QuotationsUpdated = 'quotations.updated',
  SampleDataDeleteCancelled = 'sampleData.deleteCancelled',
  SampleDataDeleted = 'sampleData.Deleted',
  SampleDataDeleteRequested = 'sampleData.deleteRequested',
  SubscriptionDeactivated = 'subscription.deactivated',
  TaskAdded = 'task.added',
  TaskMarkedAsDone = 'task.markedAsDone',
  TaskUpdated = 'task.updated',
  TeamAdded = 'team.added',
  TeamUpdated = 'team.updated',
  TimetrackingActionTriggered = 'timetrackingAction.triggered',
  TimetrackingAdded = 'timetracking.added',
  TimetrackingDeleted = 'timetracking.deleted',
  TimetrackingStartedAdding = 'timetracking.startedAdding',
  TimetrackingUpdated = 'timetracking.updated',
  TimetrackingStartedTimer = 'timetracking.startedTimer',
  TimetrackingStoppedTimer = 'timetracking.stoppedTimer',
  TrackingAdded = 'tracking.added',
  TrackingDeleted = 'tracking.deleted',
  TrackingUpdated = 'tracking.updated',
  TrendstopAdded = 'trendstop.added',
  UserDataTransferred = 'user.dataTransferred',
  UserDeactivated = 'user.deactivated',
  UserInvited = 'user.invited',
  UserUpdated = 'user.updated',
}

export default EventBusEventName;
